import React, { useContext, useEffect, useRef, useState } from 'react';
import StylesContext from '../context/StylesContext';
import api from '../api';
import { useHistory, useParams } from 'react-router-dom';
import MainContainer from '../components/MainContainer';
import CategoriesCard from '../components/CategoriesCard';
import StyledContainer from '../components/StyledContainer';
import '../styles/CategoryList.css';
import MainLogoContainer from '../components/MainLogoContainer';
import StyledTitle from '../components/StyledTitle';
import TopText from '../components/TopText';
import useTextToSpeech from '../hooks/useTextToSpeech';
import audioBip from '../assets/audios/bip.mp3';
import useAudioRecorder from '../hooks/useAudioRecorder';
import VocalInterfaceContext from '../context/VocalInterfaceContext';
import categoriesProps from '../interfaces/CategoryProps';
import checkCategory from '../helpers/checkCategory';
import menuItemsProps from '../interfaces/MenuItemProps';
import { getItemName } from '../helpers/extractItemName';
import checkItemName from '../helpers/checkItemName';
import useSessionStorage from '../hooks/useSessionStorage';
import useChart from '../hooks/useChart';
import ItemsList from '../components/ItemsList';
import Footer from '../components/Footer';

const CategoriesListVocal = () => {
  const { styles, setStyles } = useContext(StylesContext);
  const [ categories, setCategories ] = useState<Array<categoriesProps>>();
  const [ textToSpeechCategories, setTextToSpeechCategories ] = useState<string>('');
  const [ played, setPlayed ] = useState(false);
  const [ showItems, setShowItems ] = useState(false);
  const [items, setItems] = useState<Array<menuItemsProps>>();
  // const { textToSpeech, audioRef } = useTextToSpeech();
  const { startRecording } = useAudioRecorder();
  const { currentText, setCurrentText } = useContext(VocalInterfaceContext);
  const history = useHistory();
  const categoryPlayedRef = useRef<boolean>(false);
  const currentItemsStringRef = useRef<string>();
  const currentCategoryRef = useRef<string>();
  const currentItemRef = useRef<menuItemsProps>();
  const {sessionStorageHandler} = useSessionStorage();
  const updateChartQuantity = useChart();

  const audioRef = useRef<HTMLAudioElement>(null);
  const { textToSpeech } = useTextToSpeech(audioRef);
  
  const { menu } = useParams<{menu: string}>();

  const handleClick = () => {
    setPlayed(false);
    categoryPlayedRef.current = false;
    textToSpeech(textToSpeechCategories);
  };

  const handleAudioEnd = () => {
    if (!played) {
      setPlayed(true);
      if (audioRef.current) {
        audioRef.current.src = audioBip;
        audioRef.current.play()
          .then(() => {
            if (audioRef.current) {
              audioRef.current.onended = () => {
                startRecording();
              }
            }
          });
      };
    };
  };

  const handleChart = (menuItemEL: menuItemsProps) => {
    sessionStorageHandler(menuItemEL);
    updateChartQuantity();
  };

  const getCategoryItems = async (categoryName: string) => {
    try {
      const { data } = await api.get(`menu_itens/category/?url_id=${menu}&category_name=${categoryName}`);
      setItems(data);
      const itemsNames = getItemName(data);
      currentItemsStringRef.current = itemsNames;
      return itemsNames;
    } catch(error: any) {
      console.error(error.message);
    };
  };

  useEffect(() => {
    if (currentText !== '') {
      if (categories && !categoryPlayedRef.current) {
      const handleVoiceCommand = async () => {
          const isCategory = checkCategory(categories, currentText);
          if (isCategory) {
            categoryPlayedRef.current = true;
            currentCategoryRef.current = isCategory;
            setShowItems(true);
            await getCategoryItems(isCategory);
            setPlayed(false);
            textToSpeech(`Dentro da seção ${currentCategoryRef.current} temos as seguintes opções: ${currentItemsStringRef.current}. Diga uma das opções para ouvir mais detalhes. Ou diga Repita para ouvir as opções novamente. Ou diga menu principal para retornar ao menu principal.`);
          } else {
            textToSpeech('Opção não encontrada.', () => {
              setCurrentText('');
              setPlayed(false);
              textToSpeech(textToSpeechCategories);
            });
          };
        };
        handleVoiceCommand();
      } else if (currentText === 'menu principal' && categoryPlayedRef.current) {
        setShowItems(false);
        setPlayed(false);
        categoryPlayedRef.current = false;
        textToSpeech(textToSpeechCategories);
      } else if (currentText === 'repita') {
        setPlayed(false);
        setCurrentText('');
        textToSpeech(`Dentro da seção ${currentCategoryRef.current} temos as seguintes opções: ${currentItemsStringRef.current}. Diga uma das opções para ouvir mais detalhes. Ou diga Repita para ouvir as opções novamente. Ou diga menu principal para retornar ao menu principal.`);      
      } else if (currentText === 'descrição') {
        if (currentItemRef.current) {
          textToSpeech(`${currentItemRef.current.description}.`, () => {
            setPlayed(false);
            textToSpeech('Para adicionar aos pedidos diga Adicionar. Para ouvir novamente as opções diga repita. Para revisar os pedidos diga pedidos. Ou diga menu principal para retornar ao menu principal.');          
          });
        };
      } else if (currentText === 'pedidos') {
        setCurrentText('');
        history.push(`/cardapio/${styles.urlId}/chartvocal`);
      } else if (currentText === 'adicionar') {
        if (currentItemRef.current) {
          handleChart(currentItemRef.current);
          setPlayed(false);
          textToSpeech(`${currentItemRef.current.item_name} adicionado aos pedidos. Para ouvir novamente as opções diga repita. Para revisar os pedidos diga pedidos. Ou diga menu principal para retornar ao menu principal.`);
        };
      } else if (items && categoryPlayedRef.current) {
        const itemEl = checkItemName(items, currentText);
        if (itemEl) {
          currentItemRef.current = itemEl;
          setCurrentText('');
          setPlayed(false);
          textToSpeech(`Para ouvir a descrição de ${currentItemRef.current?.item_name} diga descrição. Para adicionar aos pedidos diga adicionar. Ou diga repita para ouvir novamente as opções.`)
        } else {
          textToSpeech('Comando inválido', () => {
            setCurrentText('');
            setPlayed(false);
            textToSpeech(`Dentro da seção ${currentCategoryRef.current} temos as seguintes opções: ${currentItemsStringRef.current}. Diga uma das opções para ouvir mais detalhes. Ou diga Repita para ouvir as opções novamente. Ou diga menu principal para retornar ao menu principal.`);
          });
        };
      };
    }
  }, [currentText]);

  useEffect(() => {
    if (textToSpeechCategories !== '') {
      setPlayed(false);
      categoryPlayedRef.current = false;
      textToSpeech(textToSpeechCategories);
    };
  }, [textToSpeechCategories]);
  
  useEffect(() => {
    const getStyles = async () => {
      try {
        const { data } = await api.get(`menu_styles/${menu}`);
        setStyles(data);
      } catch(error: any) {
      console.error(error.message);
      };
    };    
    const getCategories = async () => {
      try {
        const { data } = await api.get(`categories/?url_id=${menu}`);
        setCategories(data);        
      } catch(error: any) {
        console.error(error.message);
      }
    };
    const getTextToSpeech = async () => {
      try {
        const { data } = await api.get(`cardapios/${menu}`);        
        setTextToSpeechCategories(data.categoriesTextToSpeech);
      } catch(error: any) {
        console.error(error.message);
      }
    };
    getStyles();
    getCategories();
    getTextToSpeech();
  }, [menu]);  

  return (
    <MainContainer $backgroundColor={styles.bgColor} className='categories_list_page'>
      { !showItems ?
        (
          <>
          <StyledContainer className='logo_client_categories_wrapper' onClick={handleClick}>
            <TopText />
          <MainLogoContainer wrapperClass='logo_client_categories' />
          </StyledContainer>
          <StyledContainer className='container_title_icon'>
            <StyledContainer className='menu_icon_wrapper'>
              <svg viewBox="0 0 56 77" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M47.097 14.2443C48.1948 14.2443 49.2574 14.2443 50.3225 14.2443C53.8319 14.2469 55.9872 16.4116 55.9948 19.9689C56.0048 24.7593 55.9973 29.5471 55.9973 34.3374C55.9973 46.5993 55.9973 58.8613 55.9998 71.1232C55.9998 72.2676 55.8868 73.3816 55.2763 74.3767C54.1735 76.1718 52.5583 77.0022 50.4707 77.0022C39.6487 76.9921 28.8267 76.9972 18.0022 76.9972C13.8974 76.9972 9.7927 76.9972 5.68796 76.9972C2.17608 76.9972 0.00314009 74.8273 0.00314009 71.2852C-0.00188406 57.8966 0.000628019 44.5055 0.000628019 31.1143C0.000628019 26.7265 0.000628019 22.3388 0.000628019 17.9485C0.000628019 14.8646 1.23154 13.1582 4.13299 12.1935C16.0226 8.24376 27.9073 4.29402 39.7944 0.34174C43.0475 -0.739376 46.1047 0.817735 46.8709 3.98006C47.0116 4.55733 47.0292 5.17258 47.0342 5.77011C47.0518 8.40327 47.0417 11.0364 47.0443 13.6696C47.0443 13.8367 47.0744 14.0063 47.097 14.2443ZM4.49222 45.6246C4.49222 54.0735 4.49222 62.5249 4.49222 70.9738C4.49222 72.4043 4.56507 72.4778 5.94922 72.4778C20.6524 72.4778 35.3531 72.4778 50.0562 72.4778C51.4178 72.4778 51.5082 72.3891 51.5082 71.0422C51.5082 54.0912 51.5082 37.1427 51.5082 20.1917C51.5082 18.8498 51.4178 18.7638 50.0512 18.7638C35.348 18.7638 20.6474 18.7638 5.9442 18.7638C4.58265 18.7638 4.49473 18.8498 4.49473 20.1993C4.49473 28.6736 4.49473 37.1503 4.49473 45.6246H4.49222ZM12.7117 14.1076C12.7117 14.1405 12.7117 14.1734 12.7117 14.2064H42.51C42.525 13.9279 42.5476 13.6848 42.5476 13.4417C42.5501 10.8845 42.5527 8.32731 42.5476 5.76758C42.5476 4.48897 42.2537 4.27376 41.0705 4.6662C35.9761 6.36004 30.8841 8.05387 25.7896 9.7477C21.4286 11.1985 17.0702 12.6518 12.7092 14.1026L12.7117 14.1076Z" fill={styles.menuIconColor}/>
                <path d="M25.7073 28.1977C25.9384 25.7443 26.5539 24.8379 27.9782 24.8202C29.3976 24.7999 29.9904 25.6557 30.3095 28.2129C32.809 28.6535 35.0849 29.651 37.0694 31.2816C39.7272 33.4666 41.4254 36.2567 42.1438 39.6343C42.2493 40.133 42.38 40.3406 42.9276 40.3685C44.2942 40.4394 45.2086 41.4243 45.1709 42.6776C45.1332 43.9359 44.1686 44.8575 42.797 44.8601C32.9245 44.8702 23.0521 44.8702 13.1821 44.8601C11.8206 44.8601 10.8559 43.9106 10.8333 42.6523C10.8132 41.4268 11.7101 40.4419 13.0289 40.3761C13.5991 40.3482 13.7373 40.1356 13.8679 39.6115C15.3526 33.6261 19.0604 29.8536 25.0215 28.3648C25.2376 28.3116 25.4561 28.261 25.7098 28.2002L25.7073 28.1977ZM18.347 40.2698H37.6573C36.7303 35.8212 32.5829 32.5551 27.9657 32.5753C23.3761 32.5956 19.2513 35.8693 18.3495 40.2698H18.347Z" fill={styles.menuIconColor}/>
                <path d="M27.9199 64.51C23.2198 64.51 18.5222 64.515 13.8221 64.5074C12.1893 64.5049 11.0865 63.1858 11.4557 61.7047C11.7069 60.6868 12.5937 60.0058 13.7216 59.9956C15.2138 59.983 16.706 59.9931 18.1956 59.9931C26.1765 59.9931 34.1574 59.9906 42.1382 59.9931C44.0022 59.9931 45.1552 61.6793 44.3639 63.2491C43.9143 64.1429 43.1481 64.5125 42.1658 64.5125C37.418 64.5049 32.6677 64.51 27.9199 64.51Z" fill={styles.menuIconColor}/>
                <path d="M19.3191 55.4811C17.6058 55.4811 15.8901 55.4862 14.1769 55.4811C12.7173 55.4761 11.7226 54.5697 11.7125 53.2455C11.7 51.8884 12.6998 50.9642 14.2045 50.9642C17.6084 50.9592 21.0122 50.9592 24.4161 50.9642C25.9032 50.9642 26.9483 51.9162 26.9357 53.2354C26.9256 54.5621 25.8907 55.4761 24.3884 55.4811C22.6978 55.4862 21.0097 55.4811 19.3191 55.4811Z" fill={styles.menuIconColor}/>
              </svg>
            </StyledContainer>
            <StyledTitle
              className='title_categories_list'
              $textColor={styles.textColor}
              >
                CARDÁPIO
            </StyledTitle>
          </StyledContainer>
          <StyledContainer className='categories_card_container'>
            {
              categories?.map(categorieEl => (
                <CategoriesCard
                isButton={false}
                key={categorieEl.category_name}
                categorieElement={categorieEl.category_name}
                categorieImage={categorieEl.category_image}
                />
              ))
            }
          </StyledContainer>
          </>
        ) : (
          items?.length && 
          <>
            <MainLogoContainer wrapperClass='main-logo-items-list'/>
            {
              items.map(itemEl => (
                <ItemsList item_name={itemEl.item_name} price={itemEl.price} key={itemEl.item_name} />
              ))
            }
          </>
        )
      }
      <Footer $footerLogoColor={ styles.footerColor } classCategories='footer-categories' />
      <audio ref={audioRef} onEnded={handleAudioEnd}/>
    </MainContainer>
  )
}

export default CategoriesListVocal;